/**
  * Definiert allgemeine Attribute für Positionierung, Größe, etc.
  * @namespace v3sWbtPlayerApp:page:generalDirectives
  */

/**
 * Adds an background-image to the element
 */
angular.module('v3sWbtPlayerApp').directive('v3sFile', ['v3sContentMediaPath', function (v3sContentMediaPath) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            if (attrs.v3sFile != "") {
                //Ausnahmen
                if (element[0].tagName.toLowerCase() == 'v3s-graphic' || element[0].tagName.toLowerCase() == 'v3s-video' || element[0].tagName.toLowerCase() == 'v3s-audio' || element[0].tagName.toLowerCase() == 'v3s-hypertext') return;
                element.css({
                    'background-image': 'url(./' + v3sContentMediaPath + attrs.v3sFile + ')'
                })
            }
        }
    }
}]);

/**
 * Adds the style attribute "top" to the element
 * @class directive_v3sTop
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 */
angular.module('v3sWbtPlayerApp').directive('v3sTop', ['v3sContentConfig', function (v3sContentConfig) {
    return {
        restrict: 'A',
        link: function (scope, element, attributes) {
            element.css('top', attributes.v3sTop + 'px');
        }
    }
}]);

/**
 *
 * @class directive_v3sLeft
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 * @description
 * Adds the style attribute "left" to the element
 */
angular.module('v3sWbtPlayerApp').directive('v3sLeft', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attributes) {
            element.css('left', attributes.v3sLeft + 'px');
        }
    }
});


/**
 *
 * @class directive_v3sWidth
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 * @description
 * Adds the style attribute "width" to the element
 */
angular.module('v3sWbtPlayerApp').directive('v3sWidth', function () {
    return {
        restrict: 'A',
        priority: -1,
        link: function (scope, element, attributes) {
            //Ausnahmen
            if (element[0].tagName.toLowerCase() == 'v3s-source' || element[0].tagName.toLowerCase() == 'v3s-group') return;

            element.css('width', attributes.v3sWidth + 'px');
        }
    }
});

/**
 *
 * @class directive_v3sHeight
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 * @description
 * Adds the style attribute "height" to the element
 */
angular.module('v3sWbtPlayerApp').directive('v3sHeight', function () {
    return {
        restrict: 'A',
        priority: -1,
        link: function (scope, element, attributes) {
            //Ausnahmen
            if (element[0].tagName.toLowerCase() == 'v3s-source') return;
            element.css('height', attributes.v3sHeight + 'px');
        }
    }
});

/**
 *
 * @class directive_v3sVisibility
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 * @description
 * Adds the style attribute "visibilty" to the element
 */

angular.module('v3sWbtPlayerApp').directive('v3sVisibility', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attributes) {
            if (attributes.v3sVisibility == "none") {
                element.css({ visibility: "hidden" });
            }
        }
    }
});
/**
 *
 * @class directive_v3sCursor
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 * @description
 * Adds the style attribute "cursor" to the element
 */

angular.module('v3sWbtPlayerApp').directive('v3sCursor', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.addClass('cursor-' + attrs.v3sCursor);
            //remove the attribute
            element.removeAttr('data-v3s-cursor');
        }
    }
});


/**
 * Setzt die Hintergrundfarbe des Elementes
 * @class directive_v3sBackgroundColor
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 */

angular.module('v3sWbtPlayerApp').directive('v3sBackgroundColor', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.css('background-color', attrs.v3sBackgroundColor);
        }
    }
});

/**
 *
 * @class directive_v3sResponsiveWidth
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 * @description
 * Adds the style attribute "width" to the element
 */
angular.module('v3sWbtPlayerApp').directive('v3sResponsiveWidth', ['v3sResponsiveScaleService', function (v3sResponsiveScaleService) {
    return {
        restrict: 'A',
        priority: -1,
        link : function (scope, element, attributes) {
            // Skalierbar machen, wenn feste Breite vorhanden
            if (attributes.v3sResponsiveWidth == 'true' && attributes.v3sWidth && attributes.v3sWidth > 0) {
                v3sResponsiveScaleService.add(element);
            }
        }
    }
}]);

/**
 *
 * @class directive_v3sHref
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 * @description
 * Fügt ein href-Attribut ein. Links der Form "item:item_id" springen dann zum angegebenen Item.
 */
angular.module('v3sWbtPlayerApp').directive('v3sHref', ["v3sNavigationService", "v3sWbtDataService", function (v3sNavigationService, v3sWbtDataService) {
    return {
        restrict: 'A',
        priority: -1,
        link: function (scope, element, attributes) {
            var wbt, item, href;

            if (attributes.v3sHref && attributes.v3sHref.indexOf("item:") == 0) {
                wbt = v3sWbtDataService.getWbt();
                item = wbt.getItem(attributes.v3sHref.substring(5));

                if (item) {
                    href = v3sNavigationService.getHref(v3sNavigationService.getPageState(item));
                    element.attr("href", href);
                }
            }
        }
    }
}]);

/**
 *
 * @class directive_v3sClickable
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 * @description
 * Fügt dem Element die Klasse "clickable" zu. Diese Klasse wird benötigt, um die Ausnahmebehandlung des Draggable-Elements auf #pageview zu erleichtern.
 * Elemente die eigentlich nicht klickbar sind, aber den Klick bspw. an ein Input als defaultaction weitergeben sollen, werden so erkannt.
 */
angular.module('v3sWbtPlayerApp').directive('v3sClickable', [function () {
    return {
        restrict: 'A',
        link: function (scope, element, attributes) {
            element.addClass('v3s-clickable');
        }
    }
}]);